const CARDS = [
  {
    title: '反派千金的重生逆袭',
    tag: '韩漫热门',
    tags: ['穿越', '逆袭', '甜宠'],
    desc: '意外穿越成小说中的恶毒女配，她决定改写自己的命运，却意外收获了真爱与权力。',
    chapters: '更新至 128 话',
    rating: '9.6',
    img: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20webtoon%20style%20illustration%20of%20a%20noble%20woman%20in%20an%20elegant%20Victorian%20gown%20standing%20in%20a%20palace%20garden%2C%20soft%20warm%20lighting%2C%20romantic%20atmosphere%2C%20clean%20composition%2C%20manga%20cover%20style%2C%20creamy%20background%20with%20subtle%20floral%20elements%2C%20no%20text%20overlay%2C%20artistic%20illustration%20suitable%20for%20webtoon%20thumbnail&width=600&height=800&seq=manga-card-01&orientation=portrait',
  },
  {
    title: '异世界悠闲 farming 生活',
    tag: '日漫经典',
    tags: ['异世界', '日常', '治愈'],
    desc: '被传送到异世界的少年，没有成为勇者，而是选择在乡间过上种田养宠的悠闲日子。',
    chapters: '更新至 96 话',
    rating: '9.3',
    img: 'https://readdy.ai/api/search-image?query=A%20warm%20Japanese%20manga%20style%20illustration%20of%20a%20young%20man%20in%20casual%20farm%20clothes%20standing%20in%20a%20beautiful%20fantasy%20countryside%20with%20small%20creatures%2C%20golden%20sunset%20lighting%2C%20peaceful%20atmosphere%2C%20clean%20composition%2C%20manga%20cover%20style%2C%20warm%20cream%20background%2C%20no%20text%2C%20artistic%20illustration%20suitable%20for%20webtoon%20thumbnail&width=600&height=800&seq=manga-card-02&orientation=portrait',
  },
  {
    title: '灵笼：末世生存法则',
    tag: '国漫崛起',
    tags: ['科幻', '末世', '冒险'],
    desc: '末日降临，幸存者们驾驶巨大的移动堡垒在废土上求生，面对未知的噬极兽威胁。',
    chapters: '更新至 64 话',
    rating: '9.5',
    img: 'https://readdy.ai/api/search-image?query=A%20Chinese%20manhua%20style%20illustration%20of%20a%20futuristic%20post%20apocalyptic%20scene%20with%20a%20survivor%20in%20advanced%20armor%20standing%20on%20a%20ruined%20cityscape%2C%20dramatic%20orange%20and%20gray%20lighting%2C%20atmospheric%20composition%2C%20manga%20cover%20style%2C%20neutral%20background%2C%20no%20text%2C%20artistic%20illustration%20suitable%20for%20webtoon%20thumbnail&width=600&height=800&seq=manga-card-03&orientation=portrait',
  },
  {
    title: '社内恋爱禁止令',
    tag: '韩漫热门',
    tags: ['职场', '恋爱', '喜剧'],
    desc: '在公司明令禁止办公室恋情的情况下，两个互相暗恋的同事展开了一场甜蜜的秘密恋爱。',
    chapters: '更新至 82 话',
    rating: '9.1',
    img: 'https://readdy.ai/api/search-image?query=A%20Korean%20webtoon%20style%20illustration%20of%20two%20young%20office%20workers%20a%20man%20and%20a%20woman%20in%20business%20attire%20sharing%20a%20shy%20glance%20in%20a%20modern%20office%20setting%2C%20warm%20soft%20lighting%2C%20romantic%20atmosphere%2C%20clean%20composition%2C%20manga%20cover%20style%2C%20creamy%20background%2C%20no%20text%2C%20artistic%20illustration%20suitable%20for%20webtoon%20thumbnail&width=600&height=800&seq=manga-card-04&orientation=portrait',
  },
  {
    title: '剑尊归来之无双天下',
    tag: '国漫崛起',
    tags: ['修仙', '热血', '逆袭'],
    desc: '陨落千年的绝世剑尊一朝归来，却发现宗门没落、故人离散，他要用手中之剑重铸辉煌。',
    chapters: '更新至 156 话',
    rating: '9.7',
    img: 'https://readdy.ai/api/search-image?query=A%20Chinese%20manhua%20style%20illustration%20of%20a%20powerful%20swordsman%20in%20flowing%20traditional%20robes%20holding%20a%20glowing%20sword%20standing%20on%20a%20misty%20mountain%20peak%2C%20dramatic%20lighting%20with%20golden%20accents%2C%20epic%20atmosphere%2C%20clean%20composition%2C%20manga%20cover%20style%2C%20soft%20cream%20background%20with%20clouds%2C%20no%20text%2C%20artistic%20illustration%20suitable%20for%20webtoon%20thumbnail&width=600&height=800&seq=manga-card-05&orientation=portrait',
  },
];

export default function CardsSection() {
  const scrollTo = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="cards" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 text-center mb-2">
          精选推荐
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          编辑团队每日精选，为你推荐最值得追更的热门漫画
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
          {CARDS.map((card) => (
            <article key={card.title} className="bg-background-50 rounded-xl overflow-hidden group cursor-pointer transition-all hover:-translate-y-1">
              <div className="relative w-full aspect-[3/4] overflow-hidden bg-background-200">
                <img
                  src={card.img}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full text-xs font-medium bg-primary-500 text-background-50 whitespace-nowrap">
                  {card.tag}
                </span>
                <span className="absolute top-3 right-3 px-2 py-0.5 rounded-md text-xs font-bold bg-background-950/70 text-accent-300 whitespace-nowrap">
                  {card.rating}
                </span>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-semibold text-foreground-900 mb-1.5 font-heading line-clamp-1">
                  {card.title}
                </h3>
                <div className="flex flex-wrap gap-1.5 mb-2">
                  {card.tags.map((t) => (
                    <span key={t} className="px-2 py-0.5 text-xs bg-background-100 text-foreground-500 rounded whitespace-nowrap">
                      {t}
                    </span>
                  ))}
                </div>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2 mb-3">
                  {card.desc}
                </p>
                <p className="text-xs text-primary-500 font-medium whitespace-nowrap">
                  {card.chapters}
                </p>
              </div>
            </article>
          ))}
        </div>
        <div className="text-center mt-10">
          <a
            href="#ranking"
            onClick={(e) => { e.preventDefault(); scrollTo('#ranking'); }}
            className="inline-flex items-center gap-2 px-6 py-2.5 border-2 border-primary-300 text-primary-600 font-medium rounded-full hover:bg-primary-50 transition-colors text-sm cursor-pointer whitespace-nowrap"
          >
            查看更多推荐
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}